import { computed } from 'vue';
import { MaybeRefOrGetter, toValue } from '@vueuse/core';
import { IProgram } from '@/types/program';

/**
 * Hook to determine if pickup popup should be shown for BRITA program
 *
 * Conditions:
 * - show_pickup_popup must be true
 * - minimum_variable_number must be defined, not null, and greater than 0
 *
 * @param program - The program object (can be a value, ref, or getter)
 * @returns A computed ref that returns true if popup should be shown
 */
export function usePickupPopup(program: MaybeRefOrGetter<IProgram>) {
  const shouldShowPickupPopup = computed(() => {
    const prog = toValue(program);

    return (
      prog.show_pickup_popup === true &&
      prog.minimum_variable_number !== null &&
      prog.minimum_variable_number !== undefined &&
      prog.minimum_variable_number > 0
    );
  });

  return {
    shouldShowPickupPopup
  };
}
